/**
 * Measuring Guide Tabs - Optimized JavaScript
 */
(function() {
  'use strict';
  
  var MOBILE_BP = 767, positions = new Map();
  
  function isMobile() { return window.innerWidth <= MOBILE_BP; }
  
  function setTabState(tab, active) {
    tab.classList.toggle('is-active', active);
    tab.setAttribute('aria-selected', active);
    tab.setAttribute('tabindex', active ? '0' : '-1');
  }
  
  function setPanelState(panel, active) {
    panel.classList.toggle('is-active', active);
    active ? panel.removeAttribute('hidden') : panel.setAttribute('hidden', '');
  }
  
  function getPanel(container, tab) {
    return container.querySelector('.mgt-panel[data-panel="' + tab.getAttribute('data-tab') + '"]');
  }
  
  function deactivateAll(container) {
    container.querySelectorAll('.mgt-tabs__btn').forEach(function(t) { setTabState(t, false); });
    container.querySelectorAll('.mgt-panel').forEach(function(p) { setPanelState(p, false); });
  }
  
  function activateTab(container, tab) {
    deactivateAll(container);
    setTabState(tab, true);
    var panel = getPanel(container, tab);
    if (panel) setPanelState(panel, true);
  }
  
  function handleClick(container, tab, mobile) {
    var wasActive = tab.classList.contains('is-active');
    deactivateAll(container);
    
    if (!wasActive) {
      setTabState(tab, true);
      var panel = getPanel(container, tab);
      if (panel) {
        setPanelState(panel, true);
        if (mobile) setTimeout(function() { tab.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 100);
      }
    }
  }
  
  function bindTabs(container, mobile) {
    var tabs = container.querySelectorAll('.mgt-tabs__btn');
    tabs.forEach(function(tab, i) {
      var newTab = tab.cloneNode(true);
      tab.parentNode.replaceChild(newTab, tab);
      
      newTab.addEventListener('click', function(e) {
        e.preventDefault();
        handleClick(container, newTab, mobile);
      });
      
      if (!mobile) {
        newTab.addEventListener('keydown', function(e) {
          var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: -i, End: tabs.length - 1 - i };
          if (!(e.key in keys)) return;
          e.preventDefault();
          var allTabs = container.querySelectorAll('.mgt-tabs__btn');
          var n = (i + keys[e.key] + allTabs.length) % allTabs.length;
          allTabs[n].focus();
          activateTab(container, allTabs[n]);
        });
      }
    });
  }
  
  function setupMobile(container) {
    if (container.classList.contains('mgt--mobile-layout')) return;
    
    var tabs = container.querySelectorAll('.mgt-tabs__btn');
    container.querySelectorAll('.mgt-panel').forEach(function(p) {
      if (!positions.has(p)) positions.set(p, { parent: p.parentNode, next: p.nextSibling });
    });
    
    container.classList.add('mgt--mobile-layout');
    tabs.forEach(function(tab) {
      var panel = getPanel(container, tab);
      if (panel) {
        tab.parentNode.insertBefore(panel, tab.nextSibling);
        if (!tab.classList.contains('is-active')) setPanelState(panel, false);
      }
    });
    bindTabs(container, true);
  }
  
  function restoreDesktop(container) {
    if (!container.classList.contains('mgt--mobile-layout')) return;
    container.classList.remove('mgt--mobile-layout');
    
    container.querySelectorAll('.mgt-panel').forEach(function(p) {
      var pos = positions.get(p);
      if (pos) pos.next ? pos.parent.insertBefore(p, pos.next) : pos.parent.appendChild(p);
    });
    bindTabs(container, false);
  }
  
  function initContainer(container) {
    if (!container) return;
    isMobile() ? setupMobile(container) : bindTabs(container, false);
  }
  
  function handleResize() {
    document.querySelectorAll('.measuring-guide-tabs').forEach(function(c) {
      isMobile() ? setupMobile(c) : restoreDesktop(c);
    });
  }
  
  function init() {
    document.querySelectorAll('.measuring-guide-tabs').forEach(initContainer);
    var t; window.addEventListener('resize', function() { clearTimeout(t); t = setTimeout(handleResize, 150); });
  }
  
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) { var c = e.target.querySelector('.measuring-guide-tabs'); if (c) initContainer(c); });
    document.addEventListener('shopify:block:select', function(e) {
      var s = e.target.closest('.measuring-guide-tabs');
      if (s) s.querySelectorAll('.mgt-tabs__btn').forEach(function(b) { var a = b.getAttribute('data-shopify-editor-block'); if (a && a.indexOf(e.detail.blockId) !== -1) b.click(); });
    });
  }
})();